/** PagerDuty service regions. Each key is the region in the
 * `as_account-<region>.<subdomain>` scope; `mcpHost` serves that region's MCP
 * server. */
export const PagerdutyRegions = {
  us: { label: "US", mcpHost: "mcp.pagerduty.com" },
  eu: { label: "EU", mcpHost: "mcp.eu.pagerduty.com" },
} as const satisfies Record<string, { label: string; mcpHost: string }>;

export type PagerdutyRegion = keyof typeof PagerdutyRegions;
